"use client";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { useState } from "react";
import menuData from "./menuData";
import { Menu } from "@/types/menu";

interface MobileNavProps {
  isOpen: boolean;
  onClose: () => void;
}

const MobileNav = ({ isOpen, onClose }: MobileNavProps) => {
  const pathname = usePathname();
  const [openIndex, setOpenIndex] = useState(-1);

  const handleSubmenuToggle = (index: number) => {
    setOpenIndex((prev) => (prev === index ? -1 : index));
  };

  return (
    <>
      {isOpen && (
        <div
          className="fixed inset-0 z-40 bg-black/50 lg:hidden"
          onClick={onClose}
        ></div>
      )}
      <nav
        className={`fixed top-0 right-0 z-50 h-full w-64 transform bg-white p-6 shadow-lg transition-transform duration-300 lg:hidden dark:bg-gray-900 ${
          isOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <ul className="space-y-4">
          {menuData.map((menuItem: Menu, index: number) => {
            const isSubmenuActive = menuItem?.submenu?.some(
              (submenu) => submenu.path && pathname.startsWith(submenu.path),
            );
            const isActive = pathname === menuItem.path || isSubmenuActive;

            return (
              <li key={index}>
                {menuItem.path ? (
                  <Link
                    href={menuItem.path}
                    onClick={onClose}
                    className={`block text-lg font-medium ${
                      isActive
                        ? "text-primary"
                        : "hover:text-primary text-gray-800 dark:text-gray-300 dark:hover:text-white"
                    }`}
                  >
                    {menuItem.title}
                  </Link>
                ) : (
                  <>
                    <button
                      onClick={() => handleSubmenuToggle(index)}
                      className={`flex w-full items-center justify-between text-lg font-medium transition-colors duration-200 ${
                        isActive
                          ? "text-primary"
                          : "hover:text-primary text-gray-800 dark:text-gray-300 dark:hover:text-white"
                      }`}
                    >
                      {menuItem.title}
                      <svg width="20" height="20" viewBox="0 0 25 24">
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M6.29289 8.8427C6.68342 8.45217 7.31658 8.45217 7.70711 8.8427L12 13.1356L16.2929 8.8427C16.6834 8.45217 17.3166 8.45217 17.7071 8.8427C18.0976 9.23322 18.0976 9.86639 17.7071 10.2569L12 15.964L6.29289 10.2569C5.90237 9.86639 5.90237 9.23322 6.29289 8.8427Z"
                          fill="currentColor"
                        />
                      </svg>
                    </button>
                    {openIndex === index && (
                      <ul className="mt-2 space-y-1 border-l border-gray-200 pl-4 dark:border-gray-700 transition-all duration-300 ease-in-out">
                        {menuItem?.submenu?.map(
                          (submenuItem: Menu, subIndex: number) => (
                            <li key={subIndex}>
                              <Link
                                href={submenuItem.path ?? ""}
                                onClick={onClose}
                                className={`block py-1 text-base ${
                                  pathname === submenuItem.path
                                    ? "text-primary font-medium"
                                    : "hover:text-primary text-gray-600 dark:text-gray-400 dark:hover:text-white"
                                }`}
                              >
                                {submenuItem.title}
                              </Link>
                            </li>
                          ),
                        )}
                      </ul>
                    )}
                  </>
                )}
              </li>
            );
          })}
        </ul>
      </nav>
    </>
  );
};

export default MobileNav;
